<!--
 * @Descripttion: 列表筛选
 * @Author: zenghua.wang
 * @Date: 2022-02-25 11:15:27
 * @LastEditors: zenghua.wang
 * @LastEditTime: 2022-04-07 10:42:49
-->
<template>
  <div>
    <template v-for="(item, index) in option.column">
      <el-form-item
        v-if="item.search"
        :key="index"
        :label="item.label"
      >
        <!-- text -->
        <template v-if="item.type === 'text'">
          <el-input
            placeholder="请输入"
            clearable
            v-model="params[index]"
          ></el-input>
        </template>

        <!-- number -->
        <template v-if="item.type === 'number'">
          <el-input
            placeholder="请输入"
            clearable
            v-model="params[index]"
          ></el-input>
        </template>

        <!-- select -->
        <template v-if="item.type === 'select'">
          <el-select
            v-model="params[index]"
            clearable
            :multiple="item.multiple"
            placeholder="请选择"
          >
            <el-option
              v-for="dic in item.dicData"
              :key="dic.value"
              :label="dic.label"
              :disabled="dic.disabled"
              :value="dic.value"
            ></el-option>
          </el-select>
        </template>

        <!-- cascader -->
        <template v-if="item.type === 'cascader'">
          <el-cascader
            v-model="params[index]"
            :options="item.dicData"
            filterable
            clearable
            placeholder="请选择"
          ></el-cascader>
        </template>

        <!-- date -->
        <template v-if="item.type === 'date'">
          <el-date-picker
            v-model="params[index]"
            type="date"
            placeholder="请选择"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </template>

        <!-- datetime -->
        <template v-if="item.type === 'datetime'">
          <el-date-picker
            v-model="params[index]"
            type="datetime"
            placeholder="请选择"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
          >
          </el-date-picker>
        </template>

        <!-- daterange -->
        <template v-if="item.type === 'daterange'">
          <el-date-picker
            v-model="params[index]"
            type="daterange"
            range-separator="至"
            start-placeholder="请选择"
            end-placeholder="请选择"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </template>
      </el-form-item>
    </template>
  </div>
</template>

<script>
export default {
  name: 'report-mock',
  props: ['option', 'params']
}
</script>
